import React, { useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { FiSearch, FiImage, FiUsers } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "./EventPublicNav.css";

const ssKey = (id_name) => `gallery_visited_${id_name}`;

export default function EventPublicNav({ hideOnDesktop = false }) {
  const { id_name } = useParams();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const galleryPath = `/event/${id_name}/gallery`;
  const isOnGallery = pathname === galleryPath;

  // Persist gallery visit in sessionStorage so the tab stays visible
  // when the user navigates to Find Me or Social from the gallery.
  useEffect(() => {
    if (isOnGallery) sessionStorage.setItem(ssKey(id_name), "1");
  }, [isOnGallery, id_name]);

  const showGallery = isOnGallery || !!sessionStorage.getItem(ssKey(id_name));

  const tabs = [
    {
      key: "find",
      Icon: FiSearch,
      label: t("event_nav.find_me"),
      path: `/event/${id_name}`,
      exact: true,
      show: true,
    },
    {
      key: "gallery",
      Icon: FiImage,
      label: t("event_nav.gallery"),
      path: galleryPath,
      show: showGallery,
    },
    {
      key: "social",
      Icon: FiUsers,
      label: t("event_nav.social"),
      path: `/event/${id_name}/social`,
      show: true,
    },
  ];

  const isActive = ({ path, exact }) =>
    exact ? pathname === path : pathname === path;

  return (
    <nav className={`event-public-nav${hideOnDesktop ? " event-public-nav--hide-desktop" : ""}`} aria-label="Event navigation">
      {tabs.filter((tab) => tab.show).map(({ key, Icon, label, path, exact }) => {
        const active = isActive({ path, exact });
        return (
          <Link
            key={key}
            to={path}
            state={{ from: pathname }}
            className={`event-public-nav__tab${active ? " event-public-nav__tab--active" : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <Icon size={18} aria-hidden="true" className="event-public-nav__icon" />
            <span className="event-public-nav__label">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
